/**
 * Gerador de trigramas aprimorado, mas sem normalização de acentos para manter compatibilidade
 * Inclui lógica para permitir buscas por formas singulares/plurais e variações de palavras
 * @param {string} value - Texto a ser processado
 * @returns {Array} - Array contendo trigramas e outras formas de indexação
 */
export const generateTrigam = (value) => {
  if (value.length > 0) {
    value = value.trim();
    value = value.toLowerCase();
    value = value.replaceAll("  ", " "); //Retirar espaço duplo;

    let trigam = [];
    if (value) {
      let words = value.split(" ");
      trigam = [...words];

      // Adiciona prefixos de cada palavra individualmente
      words.forEach(word => {
        if (word.length >= 3) {
          for (let i = 3; i <= word.length; i++) {
            const prefix = word.substring(0, i);
            if (!trigam.includes(prefix)) {
              trigam.push(prefix);
            }
          }
        }
      });

      // Adiciona prefixos da frase completa (sem espaços)
      const valueNoSpaces = value.replace(/\s+/g, '');
      if (valueNoSpaces.length >= 3) {
        for (let i = 3; i <= valueNoSpaces.length; i++) {
          const prefix = valueNoSpaces.substring(0, i);
          if (!trigam.includes(prefix)) {
            trigam.push(prefix);
          }
        }
      }

      // Adiciona a lógica original para compatibilidade
      for (let i = 0; i < value.length - 2; i++) {
        const suffix = value.substring(i, value.length);
        if (!trigam.includes(suffix)) {
          trigam.push(suffix);
        }
      }
      for (let i = 1; i < value.length - 2; i++) {
        const prefix = value.substring(0, value.length - i);
        if (!trigam.includes(prefix)) {
          trigam.push(prefix);
        }
      }
    }
    return trigam;
  } else {
    return [];
  }
};

/**
 * Gera trigramas normalizados (sem acentos) a partir de uma string para busca avançada
 * @param {string} str - String para gerar trigrams
 * @returns {Set<string>} - Conjunto de trigrams normalizados
 */
export const generateNormalizedTrigam = (str) => {
  if (!str || typeof str !== 'string') return new Set();

  // Normaliza a string para remover acentos
  const normalized = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const words = normalized.toLowerCase().split(/\s+/);
  const trigams = new Set();

  for (const word of words) {
    if (word.length < 3) {
      trigams.add(word);
      continue;
    }

    for (let i = 0; i <= word.length - 3; i++) {
      trigams.add(word.substring(i, i + 3));
    }

    // Adiciona versões singulares/plurais simples
    if (word.endsWith('s') && word.length > 4) {
      const singular = word.slice(0, -1);
      for (let i = 0; i <= singular.length - 3; i++) {
        trigams.add(singular.substring(i, i + 3));
      }
    } else if (word.length > 3) {
      const plural = word + 's';
      for (let i = word.length - 2; i <= word.length; i++) {
        if (i >= 0) {
          const endTrigam = plural.substring(i, i + 3);
          if (endTrigam.length === 3) {
            trigams.add(endTrigam);
          }
        }
      }
    }
  }

  return trigams;
};
